import card from "../../../assets/img/projects/Maison_Sambin/Img3.png";


function App() {
  return (
    <div className="Maison_Sambin img-footer">
        <img src={card} alt="" />
    </div>
  );
}

export default App;
